import { useState, useEffect, useRef } from 'react'
import CheckIcon from '@mui/icons-material/Check'
import Input from '@mui/material/Input'
import Typography from '@mui/material/Typography'
import { Paper } from '@components'
import { colors } from '@global/constants'
import { decodeURI } from '@utils/link'
import { Theme } from 'Theme'
import { t } from '@lingui/core/macro'

export const TextEdit = props => {
  const [newValue, setNewValue] = useState(props.data || '')
  const [height] = useState(props.parent.clientHeight)
  const inputRef = useRef(null)

  const maxLength = props.governance.max_length

  useEffect(() => {
    props.updateData(newValue)
  }, [newValue])

  useEffect(() => {
    inputRef.current.firstChild.focus()
    inputRef.current.firstChild.setSelectionRange(
      inputRef.current.firstChild.value.length,
      inputRef.current.firstChild.value.length,
    )
  }, [])

  const checkForEnter = e => {
    if (e.key === 'Enter') {
      e.stopPropagation()
      e.preventDefault()
      props.updateData(newValue)
      props.close(true)
    }
    if (e.key === 'Escape') {
      e.stopPropagation()
      e.preventDefault()
      props.updateData(props.data)
      props.close()
    }
    if (e.key === 'Tab') {
      e.stopPropagation()
      e.preventDefault()
      props.updateData(newValue)
      props.close('TAB')
    }
  }

  return (
    <Theme>
      <Input
        value={decodeURI(newValue)}
        autoFocus={true}
        ref={inputRef}
        onKeyDown={checkForEnter}
        onChange={e => {
          setNewValue(e.target.value)
        }}
        style={{
          boxSizing: 'border-box',
          height: 'initial',
          minHeight: height,
          width: '100%',
          backgroundColor: 'white',
          position: 'relative',
          paddingLeft: 4,
          paddingRight: 4,
          border: '1px solid #25515B',
          fontSize: 12.25,
        }}
        multiline={true}
        disableUnderline={true}
      />
      <div style={{ position: 'absolute', width: '100%' }}>
        <Paper elevation={5}>
          <div style={{ padding: 12 }}>
            {props.governance?.link_governance?.domain_restrictions?.length ? (
              <div>
                <Typography variant="body1">
                  {t`Link must be to one of the following domains`}
                </Typography>
                <ul>
                  {props.governance?.link_governance?.domain_restrictions.map(domain => (
                    <li key={domain}>
                      <Typography variant="body2" style={{ color: 'black' }}>
                        {domain.domain || domain}
                      </Typography>
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <CheckIcon style={{ marginRight: 8, color: colors.green.main }} />{' '}
                <div>{t`Any domain is allowed`}</div>
              </div>
            )}
          </div>
          <div style={{ borderTop: '1px solid #ccc', padding: 12 }}>
            <Typography variant="caption" style={{ color: colors.gray.dark }}>
              LENGTH: {newValue.length}
              {maxLength && ` / ${maxLength}`}
            </Typography>
          </div>
        </Paper>
      </div>
    </Theme>
  )
}
